var _rect, _path, _path2, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgSearch = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.375 19.375C37.8453 19.375 41.2083 20.5783 43.8909 22.7799C46.5735 24.9815 48.4097 28.0451 49.0867 31.4487C49.7637 34.8524 49.2396 38.3855 47.6037 41.446C45.9678 44.5066 43.3213 46.9052 40.1151 48.2332C36.9089 49.5612 33.3415 49.7365 30.0206 48.7291C26.6997 47.7217 23.8308 45.594 21.9028 42.7085C19.9748 39.823 19.107 36.3583 19.4472 32.9047C19.7873 29.4511 21.3145 26.2222 23.7684 23.7684C25.158 22.3711 26.8109 21.2633 28.6316 20.5091C30.4522 19.755 32.4044 19.3695 34.375 19.375ZM34.375 10C20.9125 10 10 20.9125 10 34.375C10 47.8375 20.9125 58.75 34.375 58.75C47.8375 58.75 58.75 47.8375 58.75 34.375C58.75 20.9125 47.8375 10 34.375 10Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.168 65.8633L65.8516 69.1797C65.5913 69.4416 65.2818 69.6493 64.9409 69.7911C64.6 69.9329 64.2344 70.0059 63.8652 70.0059C63.496 70.0059 63.1305 69.9329 62.7896 69.7911C62.4487 69.6493 62.1392 69.4416 61.8789 69.1797L50.1953 57.4961C49.9344 57.2342 49.7276 56.9235 49.5868 56.5817C49.4461 56.2398 49.3741 55.8736 49.375 55.5039V53.5938L53.5938 49.375H55.5039C55.8736 49.3741 56.2398 49.4461 56.5817 49.5868C56.9235 49.7276 57.2342 49.9344 57.4961 50.1953L69.1797 61.8789C69.7045 62.4099 69.9979 63.127 69.9957 63.8735C69.9935 64.6201 69.6959 65.3355 69.168 65.8633Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 34.375,
    y1: 10,
    x2: 34.375,
    y2: 58.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 59.6854,
    y1: 49.375,
    x2: 59.6854,
    y2: 70.0059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0D3DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0D3DA"
  })))));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgSearch);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/search.88ee6428f7e9a0b81ba590ea6bfdb579.svg";